import { Pagination } from "semantic-ui-react";
import styles from './customPagination.module.scss'

type Props = {
    page: number;
    totalPages: number;
    onPageChange: (page: number) => void;
};

const CustomPagination = ({ page, totalPages, onPageChange }: Props) => {
    return (
        <div className={styles.customPagination} >
            <Pagination
                totalPages={totalPages}
                activePage={page}
                onPageChange={(e, { activePage }) => {
                    if (typeof activePage === "number") {
                        onPageChange(activePage);
                    }
                }}
            />
        </div>

    );
};

export default CustomPagination;